import Vue from 'vue'
import Router from 'vue-router'
import ask from './views/ask.vue'
import diy from './views/diy.vue'
import zh from './views/zh.vue'
import rz from './views/rz.vue'
import gj from './views/gj.vue'
import Home from './views/Home.vue'
import FriendChat from './views/chat/FriendChat.vue'
import HrInfo from './views/HrInfo.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/diy',
            name: 'diy',
            component: diy,
            hidden: true
        }, 
        {
            path: '/zh',
            name: 'zh',
            component: zh,
            hidden: true
        }, 
        {
            path: '/rz',
            name: 'rz',
            component: rz,
            hidden: true
        }, 
        {
            path: '/gj',
            name: 'gj',
            component: gj,
            hidden: true
        }, 
        {
            path: '/xundao',
            name: 'xundao',
            component: ask,
            hidden: true
        }, 
        {
            path: '*',
            redirect: to => {
                return '/diy';
            }
        }
    ]
})
